import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { UserDetailContext } from "../../../utils/Context";
import { Selector, SINGLE } from "../../Selectors/Selector";

const PLOSubjectSelect = ({
  academicSubjects,
  selectHandler,
  defaultSubject,
  hierarchySubjects,
  clear,
}) => {
  const userDetails = useContext(UserDetailContext);
  const [academicSubjectOptions, setAcademicSubjectOptions] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (academicSubjects.length > 0 && userDetails.role) {
      setLoading(true);
      const selectOptions = [];
      academicSubjects.forEach((s) => {
        if (!userDetails.isAC()) {
          if (
            userDetails.ac_subjects.includes(s.title) &&
            (!hierarchySubjects ||
              hierarchySubjects.length === 0 ||
              hierarchySubjects.includes(s.id))
          ) {
            if (s.title) {
              // temp to exclude the null string title acsub
              if (s.title !== "" && s.title !== " ") {
                selectOptions.push({ id: s.id, label: s.name });
              }
            }
          }
        } else {
          if (
            s.title &&
            (!hierarchySubjects ||
              hierarchySubjects.length === 0 ||
              hierarchySubjects.includes(s.id))
          ) {
            // temp to exclude the null string title acsub
            if (s.title !== "" && s.title !== " ") {
              selectOptions.push({ id: s.id, label: s.name });
            }
          }
        }
      });
      setAcademicSubjectOptions(selectOptions);
      setLoading(false);
    }
  }, [academicSubjects, userDetails, hierarchySubjects]);

  return academicSubjectOptions ? (
    <Selector
      type={SINGLE}
      id="academic-subject-filter"
      label={t("curriculumMap.academicSubjectFilterLabel")}
      options={academicSubjectOptions}
      selectHandler={selectHandler}
      selectedItemId={!loading && defaultSubject ? defaultSubject : ""}
      clear={clear}
      placeholder={loading ? t("global.loading") + "..." : ""}
      interaction={!loading}
    />
  ) : (
    <Skeleton height={68} />
  );
};

export default PLOSubjectSelect;
